import React from "react";
import { Scale, ChevronLeft } from "lucide-react";

export default function Terms({ onBack }) {
  return (
    <div className="min-h-screen bg-black text-zinc-400 font-mono p-8 max-w-3xl mx-auto">
      <button
        onClick={onBack}
        className="flex items-center gap-2 text-green-500 hover:text-white mb-8 uppercase text-xs"
      >
        <ChevronLeft size={16} /> Back to the Street
      </button>

      <div className="border-l-4 border-green-600 pl-6 mb-12">
        <Scale size={48} className="text-green-500 mb-4" />
        <h1 className="text-4xl font-black italic text-white uppercase">
          Terms of Service
        </h1>
        <p className="text-xs text-zinc-600 mt-2 tracking-widest uppercase">
          Effective Date: January 2026
        </p>
      </div>

      <div className="space-y-8 text-sm leading-relaxed">
        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            1. Acceptance of Terms
          </h2>
          <p>
            By entering Trap Tycoon, you agree to these terms. If you can't
            handle the heat, stay out of the kitchen. We reserve the right to
            ban any player for any reason without notice.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            2. Age Requirement
          </h2>
          <p>
            This is a simulation of street business. You must be at least 18
            years old to participate. By using this service, you represent that
            you meet this age requirement.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            3. Virtual Goods & Currency
          </h2>
          <p>
            All "cash," "items," "territory," and "assets" in Trap Tycoon are
            purely virtual and have ZERO real-world value. They cannot be
            redeemed for legal tender. We are not responsible for lost data or
            "stolen" virtual goods within the game mechanics.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">4. Conduct</h2>
          <p>
            Cheating, exploiting bugs, or harassment of other players is grounds
            for an immediate perma-ban. Use of automation (bots) is strictly
            prohibited.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            5. Partner Platforms & Affiliates
          </h2>
          <p>
            Your reputation follows you. We work closely with our community
            partners to maintain a safe environment. Please note that being
            banned from our partner platforms—specifically the **Encova Discord
            Community**—can result in an immediate and synchronized ban from
            Trap Tycoon at the discretion of the administration.
          </p>
        </section>

        <section>
          <h2 className="text-white font-bold uppercase mb-2">
            6. Limitation of Liability
          </h2>
          <p>
            Trap Tycoon is provided "AS-IS." Fallox Developments is not liable
            for any damages arising from your use of this simulation, including
            but not limited to psychological distress from being "raided" or
            loss of virtual progress.
          </p>
        </section>
      </div>
    </div>
  );
}
